import {TAppThunk} from 'core/redux/types';
import {getProductByCode} from 'modules/product-card/thunks';

/**
 * Глобальная утилита для инвалидации и обновления данных продукта по коду
 */
export const invalidateProduct = (code: string): TAppThunk<void> => {
    return async (dispatch) => {
        dispatch(getProductByCode({code}));
    };
};
